/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, createRef, Fragment } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from './fields/fieldSelect';
import Input from './fields/fieldInput';
import ModalCustom from '../design/shared/modal';
import { Error } from '../design/elements';
import { ModalFormWrapper, Button } from './css';
import {
  keyDevices,
  keySpareDevices,
  keyDevicesWereChanged,
  fieldPayment,
  paymentTypeUpfront,
  paymentTypeEasyPayment,
  fieldAvailableDiscountsAndPromotions,
  fieldCoperToFibreMigration,
  keyBusinessAppPlans,
  fieldProductNameBA,
  fieldGoogleProductEditionsBA,
  fieldESChatProductEditionsBA,
  fieldMicrosoftProductEditionsBA,
  fieldTermProductBA
} from '../utils/constant';
import { promoDeviceRate, hwcPromoDeviceRates } from '../utils/rates';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ModalForm = ({
  fields,
  formFields,
  setFormFields,
  dueNow,
  setDueNow,
  dueMonthly,
  setDueMonthly,
  open,
  header,
  onClose,
  setIsFormTouched,
  setIsFormValidated,
  orderData
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: {
      yes,
      valueEasyPayment,
      valuePaymentUpfront,
      valueNinetyNineCentDevicePromo,
      valueHardwareCreditPromo,
      devicePolycomVVX150,
      devicePolycomVVX250,
      deviceCisco7841,
      deviceYealinkT43U,
      deviceYealinkT48U,
      deviceYealinkT33G,
      devicePolycomObi302ATA,
      devicePolycomObi302ATACO,
      value1Month,
      value12Month,
      value24Month,
      value36Month
    },
    modalForm: { fieldRequiredMessage, modalFormDevices },
    formButtons: { saveButtonLabel },
    quoteForm: { promoLabel, hwcPromoLabel },
    productInOrderForOptions: {
      googleWorkspace,
      microsoft365,
      esChat,
      appHelpValueAddedService
    },
    orderRequestTypeBA: { existingAppService },
    microsoft365PlanOptions: {
      microsoftAppHelpInstallation,
      microsoftAppHelpEmailOneTime,
      microsoftAppHelpEmailMonthly
    },
    googlePlanOptions: {
      googleBusinessStandard,
      googleBusinessStarter,
      googleBusinessPlus,
      googleEnterpriseEssentials,
      googleEnterpriseStandard,
      googleEnterprisePlus,
      googleG_SuiteSetup,
      googleEmailOneTime,
      googleEmailMonthly,
      workspaceEnterpriseFrontline
    }
  } = localizedStrings;

  const nonMicrosoftOptions = [
    microsoftAppHelpInstallation,
    microsoftAppHelpEmailOneTime,
    microsoftAppHelpEmailMonthly
  ];
  const googleOptions = [
    googleBusinessStandard,
    googleBusinessStarter,
    googleBusinessPlus,
    googleEnterpriseEssentials,
    googleEnterpriseStandard,
    googleEnterprisePlus,
    workspaceEnterpriseFrontline
  ];
  const nonGoogleOptions = [
    googleG_SuiteSetup,
    googleEmailOneTime,
    googleEmailMonthly
  ];
  const [modalFormFields, setModalFormFields] = useState();
  const [isPaymentLocked, setIsPaymentLocked] = useState();
  const [formErrors, setFormErrors] = useState({});
  const key = header === modalFormDevices ? keyDevices : keySpareDevices;
  const isCoperToFibreMigration =
    _.get(orderData, fieldCoperToFibreMigration, '') === yes;
  const valueBAProductSelected = _.get(orderData, 'productInOrderFor', '');

  const getTheUpdatedValues = result => {
    const googleKeyIndex = fields.findIndex(
      item => item.fields.name === fieldGoogleProductEditionsBA
    );
    const microsoftKeyIndex = fields.findIndex(
      item => item.fields.name === fieldMicrosoftProductEditionsBA
    );
    const esChatKeyIndex = fields.findIndex(
      item => item.fields.name === fieldESChatProductEditionsBA
    );

    if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === googleWorkspace &&
      microsoftKeyIndex !== -1 &&
      esChatKeyIndex !== -1
    ) {
      // delete microsoft question //
      delete result.microsoftProductEditionsBA;
      fields.splice(microsoftKeyIndex, 1);
      // delete eschat question //
      delete result.esChatProductEditionsBA;
      fields.splice(esChatKeyIndex - 1, 1);
    } else if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === microsoft365 &&
      googleKeyIndex !== -1 &&
      esChatKeyIndex !== -1
    ) {
      // delete google question //
      delete result.googleProductEditionsBA;
      fields.splice(googleKeyIndex, 1);
      // delete eschat question //
      delete result.esChatProductEditionsBA;
      fields.splice(esChatKeyIndex - 1, 1);
    } else if (
      orderData.productInOrderFor &&
      orderData.productInOrderFor === esChat &&
      microsoftKeyIndex !== -1 &&
      googleKeyIndex !== -1
    ) {
      // delete microsoft question //
      delete result.microsoftProductEditionsBA;
      fields.splice(microsoftKeyIndex, 1);
      // delete google question //
      delete result.googleProductEditionsBA;
      fields.splice(googleKeyIndex - 1, 1);
    }

    setModalFormFields(result);
    setIsPaymentLocked(false);
  };

  const setDefaultFields = () => {
    const result = {};

    fields.forEach(item => {
      const {
        fields: { name, value, required }
      } = item;
      const ref = createRef();
      result[name] = { ref, value, required };
    });

    if (orderData.type === 'BA') {
      getTheUpdatedValues(result);
    } else {
      setModalFormFields(result);
      setIsPaymentLocked(false);
    }
  };

  useEffect(() => {
    setDefaultFields();
  }, []);

  useEffect(() => {
    if (
      formFields[keyBusinessAppPlans] &&
      formFields[keyBusinessAppPlans].length > 0
    ) {
      const dueNowCount = formFields[keyBusinessAppPlans].reduce(
        (acc, item) => {
          acc += item.oneTimeCharges * item.quantity || 0;
          return acc;
        },
        0
      );
      const monthlyCount = formFields[keyBusinessAppPlans].reduce(
        (acc, item) => {
          acc += item.monthlyCharges * item.quantity || 0;
          return acc;
        },
        0
      );
      setDueNow(dueNowCount);
      setDueMonthly(monthlyCount);
    }
  }, []);

  useEffect(() => {
    if (open) {
      setDefaultFields();
    }
  }, [open]);

  const getErrors = () => {
    const result = { ...formErrors };

    fields.forEach(item => {
      const {
        fields: { ref, name, required, fieldValidation }
      } = item;
      const fieldValue = modalFormFields[name].value;

      if (required && !fieldValue) {
        result[name] = { text: fieldRequiredMessage, ref };
      } else {
        delete result[name];
      }

      if (fieldValidation) {
        const {
          errorMessage,
          logic,
          value: expectedValue
        } = fieldValidation.fields;
        let hasError = false;
        switch (logic) {
          case 'equal':
            // eslint-disable-next-line eqeqeq
            hasError = expectedValue.split('|').includes(fieldValue);
            break;
          case 'regex':
            {
              const regexLogic = new RegExp(expectedValue);
              hasError = regexLogic.test(fieldValue);
            }
            break;
          case 'gt':
            hasError = +fieldValue > +expectedValue;
            break;
          case 'gte':
            hasError = +fieldValue >= +expectedValue;
            break;
          case 'lt':
            hasError = +fieldValue < +expectedValue;
            break;
          default:
        }
        if (hasError) result[name] = { text: errorMessage, ref };
      }
    });
    delete result.termProductBA;
    return result;
  };

  const getItemPrices = (name, value) => {
    const result = fields.find(item => item.fields.name === name);
    if (typeof result === 'undefined') return null;
    const {
      fields: { options }
    } = result;
    if (typeof options === 'undefined') return null;
    const option = options.find(item => item.fields.value === value);
    if (typeof option === 'undefined') return null;

    const {
      fields: {
        price,
        monthlyPayment,
        monthlyPayment12,
        monthlyPayment24,
        monthlyPayment36
      }
    } = option;

    return {
      price,
      monthlyPayment,
      monthlyPayment12,
      monthlyPayment24,
      monthlyPayment36
    };
  };

  const onChange = e => {
    const {
      target: { name, value }
    } = e;
    const newFields = { ...modalFormFields };
    const itemPrices = getItemPrices(name, value);
    const data = itemPrices ? { value, ...itemPrices } : { value };
    newFields[name] = { ...newFields[name], ...data };
    setModalFormFields(newFields);
  };

  const getDevicePromoPrices = (promo, deviceName) => {
    if (promo.includes(valueNinetyNineCentDevicePromo)) return promoDeviceRate;
    return _.get(hwcPromoDeviceRates, deviceName, 0);
  };

  const replaceDeviceWithPromo = (promo, device) => {
    const devicePromoLabel = promo.includes(valueNinetyNineCentDevicePromo)
      ? promoLabel
      : hwcPromoLabel;
    const devicePromoRate = getDevicePromoPrices(promo, device.name);
    return {
      ...device,
      name: `${device.name} ${devicePromoLabel}`,
      payForDevice: valuePaymentUpfront,
      oneTimeCharges: devicePromoRate,
      unitPrice: devicePromoRate,
      paymentType: paymentTypeUpfront,
      promoApplied: true,
      oldData: device
    };
  };

  const onSubmit = () => {
    const errors = getErrors();

    if (typeof errors === 'undefined') return;

    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      if (orderData.type === 'BA') {
        const businessAppPlans = formFields[keyBusinessAppPlans] || [];
        const {
          googleProductEditionsBA,
          microsoftProductEditionsBA,
          esChatProductEditionsBA,
          termProductBA,
          quantity
        } = modalFormFields;
        let selectedProduct = null;
        if (orderData.productInOrderFor.includes(googleWorkspace))
          selectedProduct = googleProductEditionsBA;
        else if (orderData.productInOrderFor.includes(microsoft365))
          selectedProduct = microsoftProductEditionsBA;
        else selectedProduct = esChatProductEditionsBA;
        let monthlyCharge = 0;
        if (termProductBA.value === value12Month)
          monthlyCharge = selectedProduct.monthlyPayment12;
        else if (termProductBA.value === value24Month)
          monthlyCharge = selectedProduct.monthlyPayment24;
        else if (termProductBA.value === value36Month)
          monthlyCharge = selectedProduct.monthlyPayment36;
        else monthlyCharge = selectedProduct.monthlyPayment;

        const newPlan = {
          name: selectedProduct.value,
          monthlyCharges: monthlyCharge || 0,
          oneTimeCharges: selectedProduct.price || 0,
          term: _.get(termProductBA, 'value', ''),
          quantity: Number(quantity.value)
        };

        businessAppPlans.push(newPlan);
        setFormFields({
          ...formFields,
          [businessAppPlans]: businessAppPlans
        });

        setDueNow(dueNow + newPlan.oneTimeCharges * newPlan.quantity);
        setDueMonthly(dueMonthly + newPlan.monthlyCharges * newPlan.quantity);
      } else {
        const devices = formFields[key] || [];
        const { device, payment, quantity } = modalFormFields;
        let newDevice = {
          name: device.value,
          payForDevice: payment.value,
          paymentType:
            payment.value === valuePaymentUpfront
              ? paymentTypeUpfront
              : paymentTypeEasyPayment,
          quantity: Number(quantity.value),
          unitPrice:
            payment.value === valuePaymentUpfront
              ? device.price
              : device.monthlyPayment,
          monthlyCharges: device.monthlyPayment,
          oneTimeCharges: device.price
        };
        const valuePromotionCode =
          formFields[fieldAvailableDiscountsAndPromotions].value || [];

        // If $0.99 promo or Hardware Credit promo is selected replace the regular device with promo device
        if (
          key === keyDevices &&
          ((valuePromotionCode.includes(valueNinetyNineCentDevicePromo) &&
            [devicePolycomVVX250, deviceCisco7841].includes(device.value)) ||
            (valuePromotionCode.includes(valueHardwareCreditPromo) &&
              [
                devicePolycomVVX150,
                devicePolycomVVX250,
                deviceYealinkT43U,
                deviceYealinkT48U,
                deviceYealinkT33G
              ].includes(device.value)))
        ) {
          const newPromoDevice = replaceDeviceWithPromo(
            valuePromotionCode,
            newDevice
          );
          newDevice = { ...newPromoDevice };
        }

        devices.push(newDevice);
        setFormFields({
          ...formFields,
          [key]: devices,
          [keyDevicesWereChanged]: true
        });
        setIsFormTouched(true);
        setIsFormValidated(false);

        // Update totals
        if (newDevice.payForDevice === valuePaymentUpfront)
          setDueNow(dueNow + newDevice.oneTimeCharges * newDevice.quantity);
        else
          setDueMonthly(
            dueMonthly + newDevice.monthlyCharges * newDevice.quantity
          );
      }
      onClose();
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const getUpdatedOptions = (field, removableOptions) => {
    const tempField = field.fields.options.filter(
      item => !removableOptions.includes(item.fields.value)
    );
    return tempField;
  };

  const getValue = (name, value) =>
    modalFormFields && modalFormFields[name] && modalFormFields[name][value];

  return (
    <ModalCustom open={open} header={header} setOpen={onClose}>
      <ModalFormWrapper>
        {fields &&
          fields.map(item => {
            const {
              fields: { type, name }
            } = item;
            let updatedOptions = item.fields.options || [];

            /**
             * IF C2F Migration flow
             * default price for PolycomObi302ATA to 0.01
             */
            if (isCoperToFibreMigration && name === 'device') {
              updatedOptions = item.fields.options.map(deviceData => {
                const updatedData = { ...deviceData };
                if (deviceData.fields.value === devicePolycomObi302ATA) {
                  updatedData.fields.price = 0.01;
                  updatedData.fields.monthlyPayment = 0;
                  updatedData.fields.label = devicePolycomObi302ATACO;
                  updatedData.fields.value = devicePolycomObi302ATACO;
                }
                return updatedData;
              });
            }
            if (name === fieldProductNameBA) {
              if (orderData.productInOrderFor.includes(googleWorkspace)) {
                if (
                  formFields.orderRequestTypeBA.value &&
                  formFields.orderRequestTypeBA.value.includes(
                    existingAppService
                  )
                ) {
                  updatedOptions = getUpdatedOptions(item, [
                    microsoft365,
                    esChat
                  ]);
                } else {
                  updatedOptions = getUpdatedOptions(item, [
                    microsoft365,
                    esChat,
                    appHelpValueAddedService
                  ]);
                }
              } else if (orderData.productInOrderFor.includes(microsoft365)) {
                if (
                  formFields.orderRequestTypeBA.value &&
                  formFields.orderRequestTypeBA.value.includes(
                    existingAppService
                  )
                ) {
                  updatedOptions = getUpdatedOptions(item, [
                    googleWorkspace,
                    esChat
                  ]);
                } else {
                  updatedOptions = getUpdatedOptions(item, [
                    googleWorkspace,
                    esChat,
                    appHelpValueAddedService
                  ]);
                }
              } else {
                updatedOptions = getUpdatedOptions(item, [
                  googleWorkspace,
                  microsoft365,
                  appHelpValueAddedService
                ]);
              }
            }

            const valueProductNameBA =
              (modalFormFields &&
                modalFormFields.productNameBA &&
                modalFormFields.productNameBA.value) ||
              null;

            if (name === fieldGoogleProductEditionsBA) {
              if (valueProductNameBA) {
                if (valueProductNameBA === googleWorkspace) {
                  updatedOptions = getUpdatedOptions(item, nonGoogleOptions);
                } else {
                  updatedOptions = getUpdatedOptions(item, googleOptions);
                }
              }
            }

            if (name === fieldMicrosoftProductEditionsBA) {
              if (valueProductNameBA) {
                if (valueProductNameBA === microsoft365) {
                  updatedOptions = getUpdatedOptions(item, nonMicrosoftOptions);
                } else {
                  updatedOptions = updatedOptions.filter(option =>
                    nonMicrosoftOptions.includes(option.fields.value)
                  );
                }
              }
            }

            if (
              [
                fieldGoogleProductEditionsBA,
                fieldMicrosoftProductEditionsBA,
                fieldESChatProductEditionsBA
              ].includes(name) &&
              !_.get(modalFormFields, 'productNameBA.value', '')
            )
              updatedOptions = [];

            if (name === fieldTermProductBA) {
              if (
                ![microsoft365, googleWorkspace].includes(
                  valueBAProductSelected
                )
              )
                return null;
              const valueGoogleEditions = _.get(
                modalFormFields,
                `${fieldGoogleProductEditionsBA}.value`,
                ''
              );
              const valueMicrosoftEditions = _.get(
                modalFormFields,
                `${fieldMicrosoftProductEditionsBA}.value`,
                ''
              );
              const valueEsChatEditions = _.get(
                modalFormFields,
                `${fieldESChatProductEditionsBA}.value`,
                ''
              );

              if (
                !valueGoogleEditions &&
                !valueMicrosoftEditions &&
                !valueEsChatEditions
              )
                updatedOptions = [];
              if (
                valueGoogleEditions ||
                valueMicrosoftEditions ||
                valueEsChatEditions
              ) {
                const {
                  monthlyPayment,
                  monthlyPayment12,
                  monthlyPayment24,
                  monthlyPayment36
                } = _.get(
                  modalFormFields,
                  valueBAProductSelected === microsoft365
                    ? fieldMicrosoftProductEditionsBA
                    : fieldGoogleProductEditionsBA,
                  {}
                );

                if (monthlyPayment === undefined)
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value1Month
                  );

                if (monthlyPayment12 === undefined)
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value12Month
                  );
                if (monthlyPayment24 === undefined)
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value24Month
                  );
                if (monthlyPayment36 === undefined)
                  updatedOptions = updatedOptions.filter(
                    option => option.fields.value !== value36Month
                  );
                if (updatedOptions.length === 0) return null;
              }
            }

            /**
             * Showing only those payment options
             * that the selected device supports
             */
            if (
              name === 'payment' &&
              _.get(modalFormFields, 'device.value', '')
            ) {
              updatedOptions = item.fields.options.filter(data => {
                const upfront = _.get(modalFormFields, 'device.price', 0);
                const monthly = _.get(
                  modalFormFields,
                  'device.monthlyPayment',
                  0
                );
                return (
                  (data.fields.value === valuePaymentUpfront &&
                    upfront !== 0) ||
                  (data.fields.value === valueEasyPayment && monthly !== 0)
                );
              });
            }

            const data = {
              ...item.fields,
              options: updatedOptions,
              ref: getValue(name, 'ref'),
              onChange
            };

            let result;
            let error;

            if (name === fieldPayment) {
              data.disabled = key === keySpareDevices;
              data.hideEmptyValue = true;
              if (isPaymentLocked) {
                data.options = data.options.filter(
                  o => o.fields.value === valuePaymentUpfront
                );
              }
            }
            if (
              formErrors &&
              Object.prototype.hasOwnProperty.call(formErrors, name)
            ) {
              error = formErrors[name];
            }

            switch (type) {
              case 'Text':
              case 'Number':
                result = <Input data={data} />;
                break;
              case 'Select':
                result = <Select data={data} />;
                break;
              default:
                result = null;
            }

            return (
              <Fragment key={name}>
                {result}
                {error && <Error text={error.text} />}
              </Fragment>
            );
          })}
        <Button
          type="button"
          onClick={onSubmit}
          className="frg-button color-green"
        >
          {saveButtonLabel}
        </Button>
      </ModalFormWrapper>
    </ModalCustom>
  );
};

ModalForm.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  formFields: PropTypes.objectOf(PropTypes.any),
  setFormFields: PropTypes.func,
  dueNow: PropTypes.number.isRequired,
  setDueNow: PropTypes.func.isRequired,
  dueMonthly: PropTypes.number.isRequired,
  setDueMonthly: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.func.isRequired,
  setIsFormValidated: PropTypes.func.isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

ModalForm.defaultProps = {
  formFields: [],
  setFormFields: () => {}
};

export default ModalForm;
